"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.btcGetAccountPaths = void 0;
exports.bitcoinGetAddress = bitcoinGetAddress;
exports.bitcoinSignTx = bitcoinSignTx;
const secp256k1_1 = __importDefault(require("@bitcoinerlab/secp256k1"));
const bitcoin = __importStar(require("@shapeshiftoss/bitcoinjs-lib"));
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const fromHexString = (hexString) => {
    const bytes = hexString.match(/.{1,2}/g);
    if (!bytes)
        throw new Error("Invalid hex string");
    return Uint8Array.from(bytes.map((byte) => parseInt(byte, 16)));
};
const getNetwork = (coin) => {
    switch (coin.toLowerCase()) {
        case "bitcoin":
            return bitcoin.networks.bitcoin;
        default:
            throw new Error(`Unsupported coin: ${coin}`);
    }
};
const btcGetAccountPaths = (msg) => {
    const slip44 = core.slip44ByCoin(msg.coin);
    if (slip44 === undefined)
        return [];
    const bip84 = core.segwitNativeAccount(msg.coin, slip44, msg.accountIdx);
    const coinPaths = {
        bitcoin: [bip84],
    };
    let paths = coinPaths[msg.coin.toLowerCase()] || [];
    if (msg.scriptType !== undefined) {
        paths = paths.filter((path) => {
            return path.scriptType === msg.scriptType;
        });
    }
    return paths;
};
exports.btcGetAccountPaths = btcGetAccountPaths;
function bitcoinGetAddress(_msg, provider) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const accounts = yield provider.requestAccounts();
        const paymentAddress = (_a = accounts.find((account) => account.purpose === "payment")) === null || _a === void 0 ? void 0 : _a.address;
        return paymentAddress;
    });
}
function addInput(psbt, input) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (input.scriptType) {
            // Phantom supposedly supports more scriptTypes but in effect, doesn't (currently)
            // https://github.com/orgs/phantom/discussions/173
            case hdwallet_core_1.BTCInputScriptType.SpendWitness: {
                psbt.addInput({
                    hash: input.txid,
                    index: input.vout,
                    nonWitnessUtxo: Buffer.from(input.hex, "hex"),
                });
                break;
            }
            default:
                throw new Error(`Unsupported script type: ${input.scriptType}`);
        }
    });
}
function addOutput(wallet, psbt, output, coin) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!output.amount)
            throw new Error("Invalid output - missing amount.");
        const address = yield (() => __awaiter(this, void 0, void 0, function* () {
            if (output.address)
                return output.address;
            if (output.addressNList) {
                const outputAddress = yield wallet.btcGetAddress({ addressNList: output.addressNList, coin, showDisplay: false });
                if (!outputAddress)
                    throw new Error("Could not get address from wallet");
                return outputAddress;
            }
        }))();
        if (!address)
            throw new Error("Invalid output - no address");
        psbt.addOutput({ address, value: BigInt(output.amount) });
    });
}
function bitcoinSignTx(wallet, msg, provider) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        // instantiation of ecc lib required for taproot sends https://github.com/bitcoinjs/bitcoinjs-lib/issues/1889#issuecomment-1443792692
        bitcoin.initEccLib(secp256k1_1.default);
        const network = getNetwork(msg.coin);
        const psbt = new bitcoin.Psbt({ network });
        psbt.setVersion((_a = msg.version) !== null && _a !== void 0 ? _a : 2);
        if (msg.locktime) {
            psbt.setLocktime(msg.locktime);
        }
        for (const input of msg.inputs) {
            yield addInput(psbt, input);
        }
        for (const output of msg.outputs) {
            yield addOutput(wallet, psbt, output, msg.coin);
        }
        if (msg.opReturnData) {
            const data = Buffer.from(msg.opReturnData, "utf-8");
            const embed = bitcoin.payments.embed({ data: [data] });
            const script = embed.output;
            if (!script)
                throw new Error("unable to build OP_RETURN script");
            // OP_RETURN_DATA output is always 0 value
            psbt.addOutput({ script, value: BigInt(0) });
        }
        const inputsToSign = yield Promise.all(msg.inputs.map((input, index) => __awaiter(this, void 0, void 0, function* () {
            const address = yield wallet.btcGetAddress({
                addressNList: input.addressNList,
                coin: msg.coin,
                showDisplay: false,
            });
            if (!address)
                throw new Error("Could not get address from wallet");
            return {
                address,
                signingIndexes: [index],
                sigHash: bitcoin.Transaction.SIGHASH_ALL,
            };
        })));
        const signedPsbtHex = yield provider.signPSBT(fromHexString(psbt.toHex()), { inputsToSign });
        const signedPsbt = bitcoin.Psbt.fromBuffer(Buffer.from(signedPsbtHex), { network });
        signedPsbt.finalizeAllInputs();
        const tx = signedPsbt.extractTransaction();
        // If this is a THORChain transaction, validate the vout ordering
        if (msg.vaultAddress && !core.validateVoutOrdering(msg, tx)) {
            throw new Error("Improper vout ordering for BTC Thorchain transaction");
        }
        const signatures = signedPsbt.data.inputs.map((input) => input.partialSig ? Buffer.from(input.partialSig[0].signature).toString("hex") : "");
        return {
            signatures,
            serializedTx: tx.toHex(),
        };
    });
}
//# sourceMappingURL=bitcoin.js.map